<template>
  <div>
    <DxForm :form-data="form_data" >
            </DxForm>
  </div>
</template>
<script>
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import DxDataGrid from 'devextreme-vue/data-grid';
import DxTextBox from 'devextreme-vue/text-box';
import {
  DxForm,
} from 'devextreme-vue/form';
export default {
    components:{
        DxForm,
    },
    data:function(){
        return{
            typeArr:[{"value":"Voucher","label":"Voucher"},{"value":"Master","label":"Master"}],
            voucherTypeArr:[{"value":"Sales","label":"Sales"},
                {"value":"Purchase","label":"Purchase"},
                {"value":"Recieve","label":"Recieve"},
                {"value":"Payment","label":"Payment"},
                {"value":"CreditNote","label":"CreditNote"},
                {"value":"DebitNote","label":"DebitNote"}],
            masterTypeArr:[
                {"value":"StockGroup","label":"StockGroup"},
                {"value":"Ledger","label":"Ledger"},
                {"value":"Group","label":"Group"},
                {"value":"StockItem","label":"StockItem"},
                {"value":"Godown","label":"Godown"},
                {"value":"Unit","label":"Unit"}
            ],
            form_data:{"type":"","SubType":"","Name":""},
            typeOptions:{
                items:['Voucher','Master']
            },
            VoucherSubTypeOptions:{
                items:['Sales','Purchase','Recieve','Payment','Credit Note','Debit Note']     
            },
            MasterSubTypeOptions:{ 
                items:['StockGroup','Ledger','Group','StockItem','Godown','Unit']  
            }
        }
    }
}
</script>
<style>

</style>